import { defineComponent as _defineComponent } from 'vue'
import { Typo } from '@travelata-libs/ui-kit';
    import { ref, watch, onUnmounted } from 'vue';
    import HintTooltip from '@ve/components/hintTooltip/desktop/HintTooltip.vue';
    import { MIR_CASHBACK_INFO } from '../../lib/filterByMirCashback';

    interface MirCashbackContentProps {
        tooltipType: string;
        autoShow?: boolean;
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'MirCashbackInfo',
  props: {
    tooltipType: { default: 'black' },
    autoShow: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { tooltipType: string, autoShow: boolean }

    

    const isForceVisible = ref(false);
    const STORAGE_KEY = 'mir_cashback_tooltip_shown';
    const AUTO_HIDE_DELAY = 7000; // 7 seconds
    let hideTimer: ReturnType<typeof setTimeout> | null = null;

    const checkIfAlreadyShown = (): boolean => {
        try {
            return sessionStorage.getItem(STORAGE_KEY) === 'true';
        } catch {
            return false;
        }
    };

    const markAsShown = (): void => {
        try {
            sessionStorage.setItem(STORAGE_KEY, 'true');
        } catch {
            // Ignore storage errors
        }
    };

    const showTooltip = (): void => {
        if (!checkIfAlreadyShown()) {
            isForceVisible.value = true;
            markAsShown();
            startAutoHideTimer();
        }
    };

    const hideTooltip = (): void => {
        isForceVisible.value = false;
        if (hideTimer) {
            clearTimeout(hideTimer);
            hideTimer = null;
        }
    };

    const startAutoHideTimer = (): void => {
        if (hideTimer) {
            clearTimeout(hideTimer);
        }
        hideTimer = setTimeout(() => {
            hideTooltip();
        }, AUTO_HIDE_DELAY);
    };

    watch(() => props.autoShow, (newValue) => {
        if (newValue) {
            showTooltip();
        }
    }, { immediate: true });

    onUnmounted(() => {
        if (hideTimer) {
            clearTimeout(hideTimer);
        }
    });

return { __sfc: true,props, isForceVisible, STORAGE_KEY, AUTO_HIDE_DELAY, hideTimer, checkIfAlreadyShown, markAsShown, showTooltip, hideTooltip, startAutoHideTimer, Typo, HintTooltip }
}

})